import { useState } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';

const testimonials = [
  {
    name: '漫画迷小王',
    avatar: 'W',
    role: '资深读者',
    rating: 5,
    text: '用了快两年了，哔咔漫画网真的是我见过资源最全的免费漫画平台。每天更新速度很快，而且画质非常清晰，完全不像免费网站的质量！',
    date: '2026-06-15',
  },
  {
    name: '二次元爱好者',
    avatar: 'E',
    role: '学生党',
    rating: 5,
    text: '不用注册就能看漫画这点太棒了，省去了很多麻烦。热门漫画基本都能找到，从日漫到国漫，覆盖很全面，推荐！',
    date: '2026-05-28',
  },
  {
    name: '追更达人',
    avatar: 'Z',
    role: '漫画博主',
    rating: 5,
    text: '作为漫画博主，我经常需要在不同平台找素材。哔咔漫画网是我最喜欢的资源站，页面清爽无广告，用户体验非常好，分类也很清晰。',
    date: '2026-06-02',
  },
  {
    name: '萌新读者',
    avatar: 'M',
    role: '入门爱好者',
    rating: 5,
    text: '刚入坑漫画两个月，哔咔漫画网帮我找到了很多好作品。排行功能特别实用，不知道看什么的时候就看榜单，每次都发现惊喜！',
    date: '2026-06-10',
  },
];

const faqs = [
  {
    q: '哔咔漫画网真的完全免费吗？',
    a: '是的，哔咔漫画网所有漫画资源均免费提供，无需注册会员即可在线阅读。我们致力于为漫画爱好者打造一个高质量的免费阅读平台。',
  },
  {
    q: '需要注册账号才能阅读吗？',
    a: '不需要。哔咔漫画网坚持无需注册的原则，打开网站即可直接浏览和阅读所有漫画，没有任何门槛，让每位漫画爱好者都能轻松畅享阅读乐趣。',
  },
  {
    q: '漫画更新频率是怎样的？',
    a: '我们每日持续更新漫画章节，热门连载漫画基本与官方同步更新。您可以通过"最新更新"板块第一时间获取最新章节。',
  },
  {
    q: '哔咔漫画网支持哪些漫画类型？',
    a: '我们收录了热血、玄幻、恋爱、搞笑、恐怖、科幻、冒险、日常等八大类漫画，涵盖国产漫画、日本漫画和韩国漫画，满足不同读者的阅读偏好。',
  },
  {
    q: '漫画画质怎么样？',
    a: '我们提供高清画质阅读体验，所有漫画图片均经过优化处理，在保障清晰度的同时兼顾加载速度，让您享受流畅的阅读体验。',
  },
  {
    q: '如何反馈漫画加载或内容问题？',
    a: '您可以通过页面底部的"联系哔咔漫画"表单提交反馈，我们的运营团队会在24小时内处理您的问题。感谢您的支持与理解！',
  },
];

export default function AboutPage() {
  const [formStatus, setFormStatus] = useState<'idle' | 'success'>('idle');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);

    const honeypot = (formData.get('contact_alt') as string || '').trim();
    if (honeypot) {
      setFormStatus('success');
      form.reset();
      return;
    }

    setFormStatus('success');
    form.reset();
  };

  const schemaData = {
    '@context': 'https://schema.org',
    '@type': 'AboutPage',
    name: '关于我们 - 哔咔漫画网',
    description: '哔咔漫画网品牌介绍、用户口碑、联系方式及常见问题解答。',
    url: 'http://xiaodianba.cn/about',
    isPartOf: { '@type': 'WebSite', name: '哔咔漫画网', url: 'http://xiaodianba.cn/' },
  };

  const breadcrumbSchema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: '首页', item: 'http://xiaodianba.cn/' },
      { '@type': 'ListItem', position: 2, name: '关于我们', item: 'http://xiaodianba.cn/about' },
    ],
  };

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.q,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.a,
      },
    })),
  };

  return (
    <>
      <title>关于我们 - 哔咔漫画网 - 免费漫画大全</title>
      <meta name="description" content="哔咔漫画网品牌介绍、用户口碑评价、联系方式及常见问题解答。免费漫画大全平台，收录热门漫画在线阅读资源。" />
      <meta name="keywords" content="哔咔漫画网,关于我们,品牌介绍,联系方式,免费漫画" />
      <link rel="canonical" href="http://xiaodianba.cn/about" />
      <meta property="og:title" content="关于我们 - 哔咔漫画网" />
      <meta property="og:description" content="哔咔漫画网品牌介绍、用户口碑评价、联系方式及常见问题解答。" />
      <meta property="og:type" content="website" />
      <meta property="og:url" content="http://xiaodianba.cn/about" />
      <meta property="og:site_name" content="哔咔漫画网" />
      <meta property="og:locale" content="zh_CN" />
      <meta name="twitter:card" content="summary" />
      <meta name="twitter:title" content="关于我们 - 哔咔漫画网" />
      <meta name="twitter:description" content="哔咔漫画网品牌介绍、用户口碑评价、联系方式及常见问题解答。" />
      <script type="application/ld+json">{JSON.stringify(schemaData)}</script>
      <script type="application/ld+json">{JSON.stringify(breadcrumbSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>

      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main className="pt-16">
          <div className="w-full px-4 md:px-6">
            <Breadcrumb items={[{ label: '关于我们' }]} />

            <section className="mt-6 pb-20">
              <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 items-start">
                <div className="w-full lg:w-[55%]">
                  <h1 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 mb-6">
                    关于哔咔漫画网
                  </h1>

                  <div className="prose max-w-none">
                    <p className="text-foreground-600 leading-relaxed mb-5">
                      <strong>哔咔漫画网</strong>成立于2019年，是国内领先的免费漫画在线阅读平台。我们始终坚持"让每一位漫画爱好者都能免费阅读到好作品"的理念，致力于打造一个内容丰富、体验出色的漫画阅读社区。
                    </p>
                    <p className="text-foreground-600 leading-relaxed mb-5">
                      截至目前，平台已累计收录超过<strong>12,000部</strong>漫画作品，涵盖热血、玄幻、恋爱、搞笑、恐怖、科幻、冒险、日常等八大主流题材。无论是日本少年Jump系热血漫、韩国Naver Webtoon精品，还是国产原创佳作，都能在哔咔漫画网找到。
                    </p>
                    <p className="text-foreground-600 leading-relaxed mb-5">
                      我们始终坚持无需注册、完全免费的原则，让每一位读者都能零门槛地享受漫画阅读的快乐。同时，我们承诺每日持续更新，确保读者不会错过任何精彩章节。
                    </p>
                    <p className="text-foreground-600 leading-relaxed">
                      未来，哔咔漫画网将继续深耕漫画领域，不断优化阅读体验，扩充内容库，为漫画爱好者提供更优质的服务。
                    </p>
                  </div>

                  <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-10">
                    {[
                      { value: '12,000+', label: '收录漫画' },
                      { value: '500万+', label: '月活读者' },
                      { value: '每日', label: '持续更新' },
                      { value: '100%', label: '免费阅读' },
                    ].map((stat) => (
                      <div key={stat.label} className="bg-background-100 rounded-xl p-4 text-center">
                        <div className="text-2xl font-bold text-primary-600">{stat.value}</div>
                        <div className="text-xs text-foreground-500 mt-1">{stat.label}</div>
                      </div>
                    ))}
                  </div>
                </div>

                <div className="w-full lg:w-[45%]">
                  <div className="bg-background-100 rounded-2xl p-6 md:p-8">
                    <h2 className="font-heading text-xl font-bold text-foreground-900 mb-5 flex items-center gap-2">
                      <i className="ri-message-3-line text-primary-500"></i>
                      联系哔咔漫画
                    </h2>

                    {formStatus === 'success' ? (
                      <div className="bg-accent-50 border border-accent-200 rounded-xl p-5 text-center">
                        <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-full bg-accent-100 text-accent-600 mb-3">
                          <i className="ri-check-line text-xl"></i>
                        </div>
                        <h3 className="font-bold text-foreground-900 mb-1">提交成功</h3>
                        <p className="text-sm text-foreground-500 mb-3">感谢您的留言，我们会尽快回复您。</p>
                        <button
                          onClick={() => setFormStatus('idle')}
                          className="text-sm text-primary-600 hover:text-primary-700 font-medium cursor-pointer"
                        >
                          继续留言
                        </button>
                      </div>
                    ) : (
                      <form
                        onSubmit={handleSubmit}
                        className="space-y-4"
                      >
                        <input
                          type="text"
                          name="contact_alt"
                          tabIndex={-1}
                          autoComplete="off"
                          aria-hidden="true"
                          readOnly
                          className="honeypot-field"
                        />
                        <div>
                          <label className="block text-sm font-medium text-foreground-700 mb-1.5">您的姓名</label>
                          <input
                            type="text"
                            name="name"
                            required
                            className="w-full px-4 py-2.5 rounded-lg bg-background-50 border border-background-200 text-sm text-foreground-800 placeholder-foreground-400 focus:outline-none focus:border-primary-400"
                            placeholder="请输入您的姓名"
                          />
                        </div>
                        <div>
                          <label className="block text-sm font-medium text-foreground-700 mb-1.5">电子邮箱</label>
                          <input
                            type="email"
                            name="email"
                            required
                            className="w-full px-4 py-2.5 rounded-lg bg-background-50 border border-background-200 text-sm text-foreground-800 placeholder-foreground-400 focus:outline-none focus:border-primary-400"
                            placeholder="请输入您的邮箱"
                          />
                        </div>
                        <div>
                          <label className="block text-sm font-medium text-foreground-700 mb-1.5">留言内容</label>
                          <textarea
                            name="message"
                            required
                            maxLength={500}
                            rows={4}
                            className="w-full px-4 py-2.5 rounded-lg bg-background-50 border border-background-200 text-sm text-foreground-800 placeholder-foreground-400 focus:outline-none focus:border-primary-400 resize-none"
                            placeholder="请描述您的问题或建议（最多500字）"
                          />
                          <p className="text-xs text-foreground-400 mt-1">最多500字符</p>
                        </div>
                        <button
                          type="submit"
                          className="w-full py-3 rounded-lg bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-colors disabled:opacity-50 cursor-pointer"
                        >
                          提交留言
                        </button>
                      </form>
                    )}

                    <div className="mt-6 pt-6 border-t border-background-200/70">
                      <h3 className="font-bold text-foreground-800 text-sm mb-3">其他联系方式</h3>
                      <ul className="space-y-2 text-sm text-foreground-600">
                        <li className="flex items-center gap-2">
                          <i className="ri-mail-line text-foreground-400"></i>
                          hello@xiaodianba.cn
                        </li>
                        <li className="flex items-center gap-2">
                          <i className="ri-phone-line text-foreground-400"></i>
                          400-888-6666
                        </li>
                        <li className="flex items-center gap-2">
                          <i className="ri-map-pin-line text-foreground-400"></i>
                          北京市海淀区中关村软件园
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>

              <div id="reputation" className="mt-16 md:mt-20">
                <div className="text-center mb-10">
                  <span className="inline-block text-xs font-medium text-accent-600 bg-accent-100/80 px-3 py-1 rounded-full mb-3">
                    用户口碑
                  </span>
                  <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900">
                    读者真实评价
                  </h2>
                  <p className="text-sm text-foreground-500 mt-2">来自数百万漫画爱好者的真实反馈</p>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
                  {testimonials.map((t) => (
                    <div key={t.name} className="bg-background-100 rounded-xl p-5">
                      <div className="flex items-center gap-3 mb-3">
                        <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 font-bold text-sm">
                          {t.avatar}
                        </div>
                        <div>
                          <div className="text-sm font-bold text-foreground-900">{t.name}</div>
                          <div className="text-xs text-foreground-400">{t.role}</div>
                        </div>
                      </div>
                      <div className="flex gap-0.5 mb-2">
                          {Array.from({ length: t.rating }).map((_, i) => (
                            <i key={i} className="ri-star-fill text-accent-400 text-xs"></i>
                          ))}
                      </div>
                      <p className="text-sm text-foreground-600 leading-relaxed">"{t.text}"</p>
                      <p className="text-xs text-foreground-400 mt-3">{t.date}</p>
                    </div>
                  ))}
                </div>
              </div>

              <div id="faq" className="mt-16 md:mt-20">
                <div className="text-center mb-10">
                  <span className="inline-block text-xs font-medium text-primary-600 bg-primary-100/70 px-3 py-1 rounded-full mb-3">
                    帮助中心
                  </span>
                  <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900">
                    常见问题解答
                  </h2>
                  <p className="text-sm text-foreground-500 mt-2">快速了解哔咔漫画网的常见疑问</p>
                </div>
                <div className="max-w-3xl mx-auto space-y-3">
                  {faqs.map((faq, index) => (
                    <details
                      key={index}
                      className="bg-background-100 rounded-xl overflow-hidden group"
                    >
                      <summary className="flex items-center justify-between px-5 py-4 cursor-pointer text-sm font-medium text-foreground-800 hover:text-primary-600 transition-colors list-none">
                        <span className="flex items-center gap-3">
                          <span className="w-7 h-7 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 text-xs font-bold flex-shrink-0">
                            {index + 1}
                          </span>
                          {faq.q}
                        </span>
                        <i className="ri-arrow-down-s-line text-foreground-400 transition-transform group-open:rotate-180"></i>
                      </summary>
                      <div className="px-5 pb-4 pl-14">
                        <p className="text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
                      </div>
                    </details>
                  ))}
                </div>
              </div>
            </section>
          </div>
        </main>
        <Footer />
      </div>
    </>
  );
}
